exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "\n.content[data-v-a92f9fa0] {\r\n    margin-bottom: 5px;\r\n    overflow: hidden;\r\n    transition: height .3s ease-in-out;\n}\na[data-v-a92f9fa0] {\r\n    text-decoration: underline;\n}\r\n", ""]);

